import * as Api from "@modules/api";
import { thunkErrorHandler } from "@utils/helpers/thunkErrorHandler";
import { thunkResponseCheckerSdk } from "@utils/helpers/thunkResponseCheckerSdk";
import { ApiMethod } from "@utils/types/common";

export const getFaqCategories: ApiMethod<
  void,
  Api.Server.CategoryOutput[],
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(async () => {
        const client = new Api.Server.Server_Faqs_Client(
          undefined,
          Api.apiClient
        );

        return client.faqs_categories_get_V1();
      }, rejectWithValue);
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const getFaqsByCategoryId: ApiMethod<
  {
    Id: number;
    PageNumber: number;
    PageSize: number;
  },
  {
    data: Api.Server.FaqOutput[];
    meta: {
      hasNextPage: boolean | undefined;
      currentPage: number | undefined;
      totalCount: number | undefined;
    };
  },
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const { Id, PageNumber, PageSize } = body;

          const client = new Api.Server.Server_Faqs_Client(
            undefined,
            Api.apiClient
          );

          return client.faqs_categories_faqs_get_V1(
            undefined,
            Id,
            PageNumber,
            PageSize
          );
        },
        rejectWithValue,
        true,
        true
      );
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};

export const createFaqEngagement: ApiMethod<
  Api.Server.UserFaqEngagementInput,
  void,
  void
> = async (body, { dispatch, rejectWithValue }) => {
  return thunkErrorHandler(
    async () => {
      return thunkResponseCheckerSdk(
        async () => {
          const client = new Api.Server.Server_Faqs_Client(
            undefined,
            Api.apiClient
          );

          return client.faqs_helpful_post_V1(body);
        },
        rejectWithValue,
        false
      );
    },
    dispatch,
    rejectWithValue,
    "page"
  );
};
